var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartmentsIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#171717",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.748 11.166C16.0557 11.166 13.873 13.3486 13.873 16.041C13.873 18.7334 16.0557 20.916 18.748 20.916C21.4404 20.916 23.623 18.7334 23.623 16.041C23.623 13.3486 21.4404 11.166 18.748 11.166Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2474 11.166C24.6492 11.166 24.1641 11.651 24.1641 12.2493C24.1641 12.8477 24.6492 13.3327 25.2474 13.3327C26.7433 13.3327 27.9557 14.5452 27.9557 16.041C27.9557 17.5368 26.7433 18.7493 25.2474 18.7493C24.6492 18.7493 24.1641 19.2344 24.1641 19.8327C24.1641 20.431 24.6492 20.916 25.2474 20.916C27.9398 20.916 30.1224 18.7334 30.1224 16.041C30.1224 13.3486 27.9398 11.166 25.2474 11.166Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7491 22C13.9506 22 9.79938 25.1189 9.10021 29.4136C8.87737 30.7824 10.0262 31.75 11.1657 31.75H26.3324C27.4719 31.75 28.6208 30.7824 28.398 29.4136C27.6988 25.1189 23.5475 22 18.7491 22Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8594 22.6132C28.2954 22.4135 27.6763 22.7087 27.4765 23.2727C27.2768 23.8367 27.5721 24.4558 28.1361 24.6555C30.5708 25.518 32.2974 27.4014 32.726 29.5832H31.206C30.6078 29.5832 30.1227 30.0682 30.1227 30.6665C30.1227 31.2647 30.6078 31.7499 31.206 31.7499H32.831C33.9705 31.7499 35.1194 30.7824 34.8966 29.4135C34.3819 26.2516 31.9796 23.7184 28.8594 22.6132Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentsIconActive);
export default __webpack_public_path__ + "static/media/departments-icon-active.8785a2e8f36b80a334100c9c19089ed2.svg";
export { ForwardRef as ReactComponent };